import { Card, Col, Row, SimpleSelect } from 'common/components'

type RunoutPeriodDropdownProps = {
  rounoutDays: number
  onChange: (value: number) => void
  displayOnly?: boolean
}

const RunoutPeriodDropdown = ({ rounoutDays, displayOnly = false, onChange }: RunoutPeriodDropdownProps) => {
  return (
    <>
      <Row>
        <Col span={17} className={'benefit_design_page_header'}>
          <h5 className={'text-bold mt-16'}>Runout Period</h5>
        </Col>
      </Row>
      <Row className={'mb-8'}>
        <Col span={17}>
          <Card>
            <Row>
              <Col>
                <div>
                  <div className="color-gray-8 mb-16">
                    At the end of every calendar year, employees have a certain time period to submit any expenses
                    incurred during the previous benefit year. You can configure the length of this period, up to 90
                    days.
                  </div>
                  <div className="mb-4">Annual Runout Period</div>
                  {displayOnly ? (
                    <div>{rounoutDays} days</div>
                  ) : (
                    <SimpleSelect
                      value={rounoutDays}
                      className="w-auto"
                      items={[
                        { id: 0, name: '0 days' },
                        { id: 30, name: '30 days' },
                        { id: 60, name: '60 days' },
                        { id: 90, name: '90 days' },
                      ]}
                      onChange={onChange}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default RunoutPeriodDropdown
